export default {
  data() {
    return {
      assignments: [
        {
          id: 1,
          name: "ASSIGN",
          alias: "ASSIGNMENTS",
          presetTabs: true,
          statisticTab: true
        },

        // {
        //   id: 2,
        //   name: "RANK 1",
        //   alias: "RANK_1"
        // },
        // {
        //   id: 3,
        //   name: "RANK 2",
        //   alias: "RANK_2"
        // },
        // {
        //   id: 4,
        //   name: "RANK 3",
        //   alias: "RANK_3"
        // },
        // {
        //   id: 5,
        //   name: "RANKS",
        //   alias: "ASSIGNED_RANKINGS"
        // }
      ]
    };
  }
};
